export const UPLOAD_MAX_FILESIZE = 4500000
export const UPLOAD_CHUNK_SIZE = 990000



// WEBPACK FOOTER //
// ./src/constants/upload.js